module.exports = __webpack_public_path__ + "img/logos.90c49ea5.png";